(function() {
  var modalWindow2 = $('.modal-window2');
  var modalWindow2Content = $('.modal-window2__content');

   $('.x-open-modal-window2').click(function(e) {
      e.preventDefault();
      modalWindow2.addClass('modal-window2--visible');
      $('[data-window-name="'+$(this).data("windowTarget")+'"]').addClass('modal-window2__content--visible');
      $('body').addClass('noscroll-body');
    });

    $('.x-close-modal-window2').click(function(e) {
      e.preventDefault();
      modalWindow2.removeClass('modal-window2--visible');
      modalWindow2Content.removeClass('modal-window2__content--visible');
      $('body').removeClass('noscroll-body');
    });

    $('.x-bg-modal-window2').click(function(e) {

      if ($(e.target).is('.x-bg-modal-window2') || $(e.target).parent().is('.x-bg-modal-window2')) {
        e.preventDefault();
        modalWindow2.removeClass('modal-window2--visible');
        modalWindow2Content.removeClass('modal-window2__content--visible');
        $('body').removeClass('noscroll-body');
      }
    });
})();
